import React from 'react';
import './Footer.css';
import { useTheme } from '../../context/ThemeContext';
import companyLogo from '../assets/images/logo.png';

const GMAIL  = 'Opramixtech@gmail.com';
const PHONE1 = '+919004429232';
const PHONE2 = '+919594049903';
const PHONE3 = '+918433959059';
const MAPS_URL = 'https://www.google.com/maps/search/Kalyan,+Maharashtra,+India';

const Footer = () => {
  const { isDayMode } = useTheme();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 90;
      const elementPosition = element.offsetTop - navbarHeight;
      window.scrollTo({ top: elementPosition, behavior: 'smooth' });
    }
  };

  const handleEmailClick  = () => {
    const gmailURL = `https://mail.google.com/mail/u/0/?view=cm&fs=1&to=${GMAIL}`;
    window.open(gmailURL, '_blank', 'noopener,noreferrer');
  };
  const handlePhone1Click = () => { window.location.href = `tel:${PHONE1}`; };
  const handlePhone2Click = () => { window.location.href = `tel:${PHONE2}`; };
  const handlePhone3Click = () => { window.location.href = `tel:${PHONE3}`; };
  const handleMapClick    = () => { window.open(MAPS_URL, '_blank', 'noopener,noreferrer'); };

  return (
    <footer className={`footer ${isDayMode ? 'day-mode' : ''}`}>
      <div className="footer-glow-line"></div>

      <div className="footer-container">

        {/* ── Brand Section ── */}
        <div className="footer-brand">
          <div className="footer-logo-wrap">
            <h3 className="footer-logo">
              {'OPRAMIX'.split('').map((letter, i) => (
                <span className="logo-letter" key={i}>{letter}</span>
              ))}
            </h3>
            <img
              src={companyLogo}
              alt="OPRAMIX Logo"
              className="footer-logo-img"
            />
          </div>
          <p className="footer-tagline">Crafting Digital Excellence</p>
          <p className="footer-description">
            We build powerful digital experiences — from sleek websites to scalable software solutions.
            Our team blends creativity with cutting-edge technology to bring your vision to life.
          </p>
        </div>

        {/* ── Quick Links ── */}
        <div className="footer-links-section">
          <h4 className="footer-heading">Quick Links</h4>
          <div className="footer-links">
            {['home', 'services', 'portfolio', 'about', 'career'].map((section) => (
              <button key={section} onClick={() => scrollToSection(section)} className="footer-link">
                {section === 'about' ? 'About Us' : section.charAt(0).toUpperCase() + section.slice(1)}
              </button>
            ))}
            <button onClick={() => scrollToSection('contact')} className="footer-link footer-link-contact">
              Contact
            </button>
          </div>
        </div>

        {/* ── Get In Touch ── */}
        <div className="footer-contact-section">
          <h4 className="footer-heading">Get In Touch</h4>

          <div className="footer-contact-inline">

            {/* Email */}
            <button onClick={handleEmailClick} className="footer-contact-item footer-contact-item--link" type="button">
              <span className="footer-contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </span>
              <span className="footer-contact-text">{GMAIL}</span>
            </button>

            {/* Phone 1 */}
            <button onClick={handlePhone1Click} className="footer-contact-item footer-contact-item--link" type="button">
              <span className="footer-contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.63 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.79a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </span>
              <span className="footer-contact-text">+91 90044 29232</span>
            </button>

            {/* Phone 2 */}
            <button onClick={handlePhone2Click} className="footer-contact-item footer-contact-item--link" type="button">
              <span className="footer-contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.63 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.79a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </span>
              <span className="footer-contact-text">+91 95940 49903</span>
            </button>

            {/* Phone 3 — bug fixed: now uses handlePhone3Click */}
            <button onClick={handlePhone3Click} className="footer-contact-item footer-contact-item--link" type="button">
              <span className="footer-contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.63 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.79a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </span>
              <span className="footer-contact-text">+91 84339 59059</span>
            </button>

            {/* Location */}
            <button onClick={handleMapClick} className="footer-contact-item footer-contact-item--link" type="button">
              <span className="footer-contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </span>
              <span className="footer-contact-text">Kalyan, Maharashtra</span>
            </button>

            {/* Company */}
            <div className="footer-contact-item footer-contact-item--company">
              <span className="footer-contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
                </svg>
              </span>
              <span className="footer-contact-text">OPRAMIX Technologies</span>
            </div>

          </div>
        </div>

      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="footer-copyright">
            © {new Date().getFullYear()} OPRAMIX Technologies. All rights reserved.
          </p>
          <div className="footer-legal">
            <a href="/privacy" className="footer-legal-link">Privacy Policy</a>
            <span className="footer-separator">•</span>
            <a href="/terms" className="footer-legal-link">Terms of Service</a>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;